import { __awaiter, __generator } from "tslib";
export function loadClearbitV2(analytics) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var response, _d, domain, name, geo, category, metrics, traits;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!window.reveal) {
                        return [2 /*return*/];
                    }
                    response = sessionStorage.getItem('cb_reveal');
                    if (response ||
                        ((_a = analytics.group().traits()) === null || _a === void 0 ? void 0 : _a.website) ||
                        !((_c = (_b = window.reveal) === null || _b === void 0 ? void 0 : _b.company) === null || _c === void 0 ? void 0 : _c.domain)) {
                        return [2 /*return*/];
                    }
                    _d = window.reveal.company, domain = _d.domain, name = _d.name, geo = _d.geo, category = _d.category, metrics = _d.metrics;
                    traits = {
                        website: domain,
                        intentSource: 'clearbit',
                        name: name,
                        country: geo.country,
                        industry: category.industryGroup,
                        number_of_employees: metrics.employeesRange,
                        annual_revenue: metrics.estimatedAnnualRevenue,
                    };
                    return [4 /*yield*/, analytics.group(null, traits)];
                case 1:
                    _e.sent();
                    sessionStorage.setItem('cb_reveal', JSON.stringify(traits));
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=clearbitV2.js.map